export default function StatsSection() {
  const stats = [
    { number: '10,000+', label: '漫画作品', icon: 'ri-book-2-line' },
    { number: '500万+', label: '月活跃读者', icon: 'ri-user-heart-line' },
    { number: '98%', label: '用户好评率', icon: 'ri-thumb-up-line' },
    { number: '365天', label: '全年无休更新', icon: 'ri-calendar-check-line' },
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            为什么选择我们
          </h2>
          <p className="mt-2 text-sm text-foreground-500">数据见证品质，信赖源自口碑</p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="flex flex-col items-center p-6 md:p-8 bg-background-100 rounded-xl border border-background-200/70"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
                {stat.number}
              </div>
              <div className="mt-1 text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}